import { put } from "@redux-saga/core/effects";
import { all, takeEvery,  call } from 'redux-saga/effects'
 import { toast } from 'react-toastify';
// import { clientListing } from "../../services/clientListingServices";
import { getbalanceresponse } from "../../services/getbalanceservice";
import { getbalancerequest, getbalancesuccess, getbalancefailure } from "./action";
import { GET_BALANCE } from "./types";

export function* getbalance(data){
    //console.log('getbalance', data)
    yield put(getbalancerequest())
    try{
        
        const result = yield call(()=>getbalanceresponse(data?.id));
        if (result.status == "ACTIVE") {
            yield put(getbalancesuccess(result));
           //  toast.success(" Successfully")
        } else {

            yield put(getbalancefailure(result))
             toast("FailListing")
        }

    }catch(error){

        yield put(getbalancefailure(error.response.data))

        // toast.error("Validation Error listing")

    }

}

export default function* GetbalancelistSaga() {
    yield all([takeEvery(GET_BALANCE, getbalance)])
}
